import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'vehicle-type-switch-component',
    templateUrl: './vehicle-type-switch.component.html',
    styleUrls: ['./vehicle-type-switch.component.scss'],
    standalone: false
})
export class VehicleTypeSwitchComponent implements OnInit {
  @Input() 
  selectedValue: string = null;
  
  @Output()
  selectedValueChange = new EventEmitter<boolean>();

  ngOnInit() {
  }

  selectItem(type) {
    this.selectedValueChange.emit(type);
  }
  
}
